<template>
  <div class="topNav">
    <img src="../../static/images/reyzar-blue.png">
    <div class="navIn">
            <ul class="clearfix">
                <a @click="toRoute('/')">
                    <li id="bannerIndex" :class="{current:this.$route.path == '/'}">首页</li>
                </a>
                <a @click="toRoute('/business')">
                    <li id="bannerBusiness" :class="{current:this.$route.path == '/business'}">主营业务</li>
                </a>
                <a @click="toRoute('/solution')">
                    <li id="bannerSolution" :class="{current:this.$route.path == '/solution' || this.$route.path == '/solutionCase1' || this.$route.path == '/solutionCase2' || this.$route.path == '/solutionCase3' || this.$route.path == '/solutionCase4' || this.$route.path == '/solutionCase5'}">解决方案</li>
                </a>
                <a @click="toRoute('/case')">
                    <li id="bannerClient" :class="{current:this.$route.path == '/case' || this.$route.path == '/caseDetail1' || this.$route.path == '/caseDetail2' || this.$route.path == '/caseDetail3' || this.$route.path == '/caseDetail4' || this.$route.path == '/caseDetail5'}">客户案例</li>
                </a>
                <a @click="toRoute('/news')">
                    <li id="bannerNews" :class="{current:this.$route.path == '/news' || this.$route.path == '/newsDetail'}">新闻中心</li>
                </a>
                <a @click="toRoute('/jobs')">
                    <li id="bannerJob" :class="{current:this.$route.path == '/jobs'}">人才招聘</li>
                </a>
                <a @click="toRoute('/culture')">
                    <li id="bannerCulture" :class="{current:this.$route.path == '/culture'}">企业文化</li>
                </a>
                <a @click="toRoute('/about')">
                    <li id="bannerAbout" :class="{current:this.$route.path == '/about'}">关于睿哲</li>
                </a>
            </ul>
        </div>
  </div>
</template>

<script>
export default {
  name: 'topNav',
  data () {
    return {
      
    }
  },

  mounted(){
  },

  methods: {
    toRoute(url){
      this.$router.push({path:url})
    }
  }

  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../assets/css/global";
  .topNav{
    width: 100%;
    height: 50px;
    line-height: 50px;
    background-color: #fafafa;
    border-bottom: 1px solid #e9e9e9;
    position: fixed;
    top: 0;
    padding: 0 20px 0;
    z-index: 999999;
    img{
        width: 113px;
        margin-top: 3px;
        vertical-align: top;
        display: inline-block;
        margin-right: 20px;
      }
    .navIn{
      width: auto;
      height: 50px;
      line-height: 50px;
      display: inline-block;
      padding: 10px 0;
      a{
        color: #313131;
        li{
          min-width: 100px;
          line-height: 30px;
          height: 30px;
          text-align: center;          
          font-size: 16px;
          float: left;
        }
        &:hover{
          color: $color;
        }
      }
      
      .current {
        background-color: #73a9f1;
        border-radius: 15px;
        color: #fff!important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/topNav.vue